import { AIModel, AIModelSpamEval } from '../api/client';

const percent = (rate: number | null, digits = 0): string =>
  rate === null ? '?' : `${(rate * 100).toFixed(rate > 0 && rate < 0.01 ? Math.max(digits, 1) : digits)}%`;

/** Cents per submission, to two significant figures (0.52¢, 3.1¢). */
export const centsPerSubmission = (costUsd: number): string => {
  const cents = costUsd * 100;
  if (cents === 0) return '0¢';
  return `${Number(cents.toPrecision(2))}¢`;
};

/** "catches 96% of spam · 0.1% real leads blocked · ~0.52¢/submission" */
export const formatSpamEval = (score: AIModelSpamEval): string =>
  [
    `catches ${percent(score.spam_caught_rate)} of spam`,
    `${percent(score.real_blocked_rate, 1)} real leads blocked`,
    `~${centsPerSubmission(score.cost_per_check_usd)}/submission`,
  ].join(' · ');

export const formatModelOption = (model: AIModel): string =>
  model.spam_eval ? `${model.name}: ${formatSpamEval(model.spam_eval)}` : model.name;

export const describeSpamEval = (score: AIModelSpamEval): string =>
  `Measured on ${score.items} ${score.labels === 'human-confirmed' ? 'human-confirmed ' : ''}submissions ` +
  `(run ${score.run}). Real leads blocked are binned as spam and their sender is banned, so keep that number low; ` +
  `${percent(score.real_flagged_rate, 1)} of real leads are flagged for review.`;
